/**
 * Helper for kicking things off in the site.
 * @module global/loader
 */
define('loader',['jquery', 'bootstrap', 'page', 'vspot'],
    function($) {
        // Don't remove! This tells Steal it can load
        Vspot.require_loaded = true;
        if (true) { // just to make this easy to comment out
            try {
                // make facebook optional, in case the service is blocked or down
                require(['facebook'],
                    function () {
                        //---------------------------------------[ Begin Facebook
                        if (FB) {
                            // Facebook is a resource we use, to loading it is a precursor to our page functioning correctly
                            FB.init({
                                appId: '1731142263830615', // app id from signup '385770938175078', // App ID from the App Dashboard
                                version: 'v19.0', // 'v3.3', // 'v2.6', // Determines which versions of the Graph API to use - see version list here https://developers.facebook.com/docs/apps/changelog/
                                cookie: true, // set sessions cookies to allow your server to access the session?
                                channelUrl: document.URL + 'fb/channel.html', // Channel File for x-domain communication
                                status: true, // check the login status upon init?
                                xfbml: true  // parse XFBML tags on this page?
                            });
                        }
                        //---------------------------------------[ End Facebook
                    },
                    function (error) {
                        // load failed
                        try { console && console.log ('Failed loading facebook ' + error); } catch (e) { }
                    }
                );

                // PWD: this appears to duplicate the function above, commenting it out
                // Load the SDK's source Asynchronously
                // (function (d) {
                //     var js, id = 'facebook-jssdk', ref = d.getElementsByTagName('script')[0];
                //     if (d.getElementById(id)) {
                //         return;
                //     }
                //     js = d.createElement('script');
                //     js.id = id;
                //     js.async = true;
                //     js.src = "//connect.facebook.net/en_US/sdk.js";
                //     ref.parentNode.insertBefore(js, ref);
                // }(document, false));
                //---------------------------------------[ End Facebook
            }
            catch (err) {
                console && console.log(err.message);
            }
        }

        $(document).ready(function() {
            // Track any clicks on demo items back to GA
            $("body").on("click", ".demo", function(event) {
                event.preventDefault();

                var label = $(this).data("demoTitle");
                if(typeof(label) === "undefined") {
                    label = window.location.pathname + " :: ";

                    var id = $(this).attr("id");
                    if(typeof(id) === "undefined") {
                        id = $(this).closest("[id]").attr("id");
                    }

                    label += id;
                }

                var target = $(this).attr("href");

                try {
                    ga('send', 'event', 'Demo Link', 'Click', label, {
                        // 'hitCallback': function() {
                        //     location.assign(target); // Called after we log it
                        // }
                    });
                    // ga('send', 'event', category, action, label, value, nonInteraction);
                    // GA4
                    gtag('event', 'click', {
                        'event_category': 'Demo Link',
                        'event_label': label,
                        'event_callback': function() {
                            location.assign(target); // Called after we log it
                        }
                    });

//                    _gaq.push(['_set', 'hitCallback', function(){
//                        location.assign(target);
//                    }], ['_setAccount', 'UA-3705553-1'], ['_trackEvent', 'Demo Link', 'Click', label]);
                } catch(e) {
                    // Just go there
                    location.assign(target);
                }
            });
        });
    }
);
